export default __webpack_public_path__ + "static/media/img-gtl-crs.e4f82600.png";